module.exports = __webpack_public_path__ + "static/media/coding.0466ede0.svg";